<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div id="navbar" class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="school.loaded == 0" />
					<div v-if="school.loaded != 0" class="navbar-text nav-title flex" id="pageTitle">
						{{ school.name }}
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="school.loaded != 0">
						<div class="d-sm-flex b-t h-100">
							<edit-pane :cancel="loadData" :save="saveSchool" :dirty="dirty" :valid="valid">
								<div class="p-4 b-b _600 nav-title">School Details</div>
								<div role="form" class="col-8">
									<div class="row m-0 pt-4">
										<div class="col-12">
											<div class="form-group" :class="{ invalid: !valid.field('name') }">
												<label>School Name</label>
												<input type="text" class="form-control" v-model="school.name" />
											</div>
										</div>
										<div class="col-12">
											<div
												class="form-group"
												:class="{ invalid: !(valid.field('ref') && valid.field('ref_char')) }"
											>
												<label>Reference ID</label>
												<input type="text" class="form-control" v-model.trim="school.ref_id" />
												<small class="form-text text-muted"
													>Reference ID must be unique within this tenant</small
												>
											</div>
										</div>
										<div class="col-12">
											<div class="form-group" :class="{ invalid: !valid.field('district') }">
												<label>District</label>
												<v-select
													class="v-select-apply"
													:options="districts"
													v-model="selectedDistrict"
													@input="updateDistrictID"
													label="name"
												>
												</v-select>
											</div>
										</div>
										<div class="col-12">
											<div class="form-group">
												<label>Building ID</label>
												<input
													type="text"
													class="form-control"
													v-model.trim="school.building_ref_id"
												/>
											</div>
										</div>
									</div>
								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveSchool"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="School"
								:objectName="school.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";

import SchoolService from "@/services/SchoolService";
import DistrictService from "@/services/DistrictService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";

export default {
	name: "SchoolEdit",

	props: ["user", "params", "query"],

	components: {
		EditPane,
		SaveOptionalModal,
		ConfigSelect
	},

	data() {
		return {
			fs: fs,
			tab: 1,
			school: {
				loaded: 0
			},

			districts: [],
			selectedDistrict: null,

			dirty: false,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {},

	created() {
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "details",
					errorMsg: "You must assign a name",
					func: () => {
						return this.school && this.school.name && this.school.name != "";
					}
				},
				ref: {
					group: "details",
					errorMsg: "You must assign a reference ID",
					func: () => {
						return this.school && this.school.ref_id && this.school.ref_id != "";
					}
				},
				ref_char: {
					group: "details",
					errorMsg:
						"Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
					func: () => {
						return this.school && this.school.ref_id && fs.isGoodRefID(this.school.ref_id);
					}
				},
				district: {
					group: "details",
					errorMsg: "You must choose a district",
					func: () => {
						return this.school && this.school.district_id;
					}
				}
			});
		},

		blankSchool() {
			return {
				schools: [],
				teachers: [],
				district_id: null,
				loaded: 0
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"school",
				(newc, old) => {
					// console.log(newc, old);
					// console.log(Utils.diff(newc, old));
					// console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			this.dirty = false;
			var loaded = this.school.loaded;
			loaded++;

			if (this.params.id != "new") {
				return BB.props({
					school: SchoolService.getSchool(this.params.id),
					districts: DistrictService.listDistricts()
				})
					.then(resps => {
						this.school = resps.school.data;
						this.school.loaded = loaded;

						this.districts = resps.districts.data.districts;
						this.selectedDistrict = _.find(this.districts, {
							id: this.school.district_id
						});
						this.updateDistrictID(this.selectedDistrict);

						this.watchChanges();
					})
					.catch(err => {
						console.log(err);
						Notie.error("School not found, adding new school instead");
						this.$router.replace("/school/new");
					});
			} else {
				return DistrictService.listDistricts()
					.then(resp => {
						this.school = this.blankSchool();
						this.school.loaded = loaded;
						this.$set(this.school, "name", "New School");
						this.$set(this.school, "ref_id", "new_school");

						this.districts = resp.data.districts;

						this.selectedDistrict = null;
						this.updateDistrictID(this.selectedDistrict);

						this.watchChanges();
					})
					.catch(err => {
						Notie.error("Failed to load districts");
					});
			}
		},

		updateDistrictID(district) {
			this.school.district_id = (district && district.id) || "";
		},

		saveSchool() {
			return SchoolService.saveSchool(this.school)
				.then(resp => {
					Notie.info("School Saved");
					if (this.school.id != resp.data.id) {
						this.$router.replace("/school/" + resp.data.id);
					}
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save school", err);
				});
		},

		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/SchoolEdit.vue